// 9fbef606107a605d69c0edbcd8029e5d
import { getPlaceSiteId } from '@tcp/core/src/utils';
import { executeStatefulAPICall } from '../../handler';
import endpoints from '../../endpoints';

const getFormattedError = (err) => {
  if (err.response && err.response.body && err.response.body.errors instanceof Array) {
    return err.response.body.errors[0].errorKey;
  }
  return 'genericError';
};

export const errorHandler = (err) => {
  throw getFormattedError(err);
};

const getWebService = (isMuleEnable) => {
  let apiService = {};

  const { phoneLookupAPI, phoneLookupWithoutMule } = endpoints;

  apiService = isMuleEnable ? phoneLookupAPI : phoneLookupWithoutMule;

  return apiService;
};

export const phoneLookup = (params) => {
  const { logonId, isMuleEnable } = params;
  const payload = {
    webService: getWebService(isMuleEnable),
  };

  if (isMuleEnable) {
    payload.body = {
      emailAddress: logonId,
    };
  } else {
    payload.header = {
      emailAddress: logonId,
      siteId: getPlaceSiteId(),
    };
  }
  return executeStatefulAPICall(payload)
    .then((res) => {
      if (res && res.body && res.body.errorMessage) {
        throw res.body;
      }
      if (isMuleEnable) {
        return res.body;
      }
      return res.body.data;
    })
    .catch((err) => {
      throw err;
    });
};

export default phoneLookup;
